import { RouteObject } from "react-router-dom";
import { AffiliatesList } from "../pages/admin/affiliates/AffiliatesList";
import { AffiliateDetail } from "../pages/admin/affiliates/AffiliateDetail";
import { AffiliateCreate } from "../pages/admin/affiliates/AffiliateCreate";

export const affiliatesRoutes: RouteObject[] = [
  {
    id: "affiliates-list",
    index: true,
    element: <AffiliatesList />,
  },
  {
    id: "affiliate-detail",
    path: ":id",
    element: <AffiliateDetail />,
  },
  {
    id: "affiliate-create",
    path: "create",
    element: <AffiliateCreate />,
  },
];
